import React, { Component, Fragment } from 'react';
import Card from 'react-bootstrap/Card';
import '../../../css/card.css';
import Axios from '../../../config/axios';
import Globals from '../../../config/globals';
import { toast, confirm } from '@rickylandino/react-messages';
import { Modal } from 'react-bootstrap';
import d2p_app_screen1 from '../../../img/d2p_app_screen1.png';
import d2p_app_screen2 from '../../../img/d2p_app_screen2.png';
import d2p_app_screen3 from '../../../img/d2p_app_screen3.png';
import d2p_app_screen4 from '../../../img/d2p_app_screen4.png';
import d2p_app_screen5 from '../../../img/d2p_app_screen5.png';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import googlePlayImg from '../../../img/g_play.png';
import appStoreImg from '../../../img/a_store.png';
import { Carousel } from 'antd';
import NumberFormat from 'react-number-format';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import * as ShowSliders from '../ShowSliders/index';
import statesList from '../../Helpers/StatesList';
import multipledevices from '../../../img/multiple-deviceSpring2020.png';

export class PremiumServicesCard extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.showInfo.name !== prevState.showInfo.name && nextProps.showInfo.show_abbrev !== prevState.showInfo.show_abbrev) {
            return { showInfo: nextProps.showInfo, formFields: nextProps.showInfo }
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            showInfo: this.props.showInfo,
            formFields: '',
            showInstructionModal: false,
            showOrderModal: false,
            showOrderModalForm: true,
            showSponsorshipsSlider: false,
            showLeadRetrievalSendEmailSlider: false
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }

    getLeadRetrievalStatus = () => {
        Axios.get(`/api/GetLeadRetrievalStatus`, {
            params: {
                id: Globals.userInfo.companyId,
                showcode: this.props.location?.state?.showcode || Globals.defaultShowCode
            }
        }).then(response => {
            let retval = response.data;

            //console.log("GetLeadRetrievalStatus: " + retval);

            if (retval) {
                this.setState({
                    showInstructionModal: true
                });
            } else {
                this.setState({
                    showOrderModal: true
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    hideShowOrderPane = () => {
        this.setState({
            showOrderModal: false,
            formFields: '',
        });
    }

    submitLeadRetrievalOrder = () => {
        if (this.state.formFields.contact && this.state.formFields.telephone && this.state.formFields.email) {
            let onlineOrder = {
                Id: Globals.userInfo.companyId,
                showcode: parseInt(this.props.location?.state?.showcode || Globals.defaultShowCode),
                contact: this.state.formFields.contact,
                phone: this.state.formFields.telephone,
                email: this.state.formFields.email
            };

            let postdata = {
                reqExhibitor: Globals.userInfo.companyName,
                currentuser: Globals.userInfo.username,
                name: this.state.showInfo.name,
                lrprice: '$250',
                onlineOrdersModel: onlineOrder
            }

            Axios.post(`/api/ProcessLeadRetrievalOrder`, postdata
            ).then(response => {
                if (response.data) {
                    this.setState({
                        showOrderModal: false
                    });

                    toast.success("Lead Retrieval Order Submitted - Thank you for your order.");
                }
            }).catch(error => {
                toast.error(
                    <span style={{ textAlign: 'center' }}>
                        Something went wrong, please try again later or call Karen C. at 800-225-4535 ext. 138 or{" "}
                        <a href="mailto:karenc@d2p.com">karenc@d2p.com</a>.
                    </span>,
                    { alignment: 'top-center', duration: 5 }
                );
            });
        } else {
            toast.error("Please fill out all fields.");
        }
    }

    render() {

        const screens = [
            d2p_app_screen1,
            d2p_app_screen2,
            d2p_app_screen3,
            d2p_app_screen4,
            d2p_app_screen5
        ];

        return (
            <Card className="showCard">
                <Card.Header><span>Lead Retrieval & Premium Marketing Services</span></Card.Header>
                <Card.Body>
                    <div className="text-center a">
                        <p onClick={this.getLeadRetrievalStatus}><u>Electronic Lead Retrieval</u></p>
                    </div>
                    <div className="text-center a">
                        <p><a href="http://d2pgraphics.com/" target="_blank" rel="noopener noreferrer" className="font-weight-normal"><u>Marketing For Manufacturers</u></a></p>
                    </div>
                    <div className="text-center a">
                        <p onClick={() => this.setState({ showSponsorshipsSlider: true })}><u>Sponsorships</u></p>
                    </div>
                    <div className="text-center a">
                        <a href="http://d2pmagazine.com/" target="_blank" rel="noopener noreferrer" className="font-weight-normal"><u>Advertising Opportunities</u></a>
                    </div>
                    {/*<div>*/}
                    {/*    <button className="btn btn-danger btn-lg" onClick={this.getPath}> Get Path</button>*/}
                    {/*</div>*/}
                </Card.Body>

                <SlidingPane
                    className='lr-slider-class'
                    overlayClassName='showCard'
                    isOpen={this.state.showInstructionModal}
                    title='Electronic Lead Retrieval'
                    onRequestClose={() => this.setState({ showInstructionModal: false })}
                    closeIcon={<i className="fas fa-chevron-right float-left"></i>}
                >
                    <div className="slide-pane-body scrollableDiv">
                        <div className="lead-retrieval-layout">
                            <div className="lead-retrieval-content">
                                <h1>Electronic Lead Retrieval - {this.state.showInfo.name}</h1>

                                <p>Your company is currently registered to use Electronic Lead Retrieval for the {this.state.showInfo.name} show.</p>

                                <h3>Getting Started</h3>
                                To ensure a smooth experience, please have all booth staff complete the following steps prior to the show:

                                <ol>
                                    <li>
                                        <b>Download the "D2P Shows" App (available for Apple and Android devices):</b>
                                        <ul>
                                            <li>
                                                iOS: <a href="https://itunes.apple.com/us/app/d2p-shows/id845230786?mt=8" target="_blank" rel="noopener noreferrer">
                                                    https://itunes.apple.com/us/app/d2p-shows/id845230786?mt=8
                                                </a>
                                            </li>
                                            <li>
                                                Android: <a href="https://play.google.com/store/apps/details?id=com.d2p.d2pshows" target="_blank" rel="noopener noreferrer">
                                                    https://play.google.com/store/apps/details?id=com.d2p.d2pshows
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li><b>Open the app and select the {this.state.showInfo.name} show</b></li>
                                    <li>Tap <b>"Lead Retrieval"</b></li>
                                    <li>
                                        <b>Scan your customized QR code</b>
                                        <ul>
                                            <li>This code will be emailed to you approximately one week prior to the show</li>
                                        </ul>
                                    </li>
                                </ol>

                                <h3>What's Included in Your Package</h3>
                                <ul>
                                    <li>Unlimited device access for your full booth staff</li>
                                    <li>Built-in badge scanning via the mobile app</li>
                                    <li>On-site technical support during the show</li>
                                    <li>
                                        Lead access and export options, including ability to:
                                        <ul>
                                            <li>View and manage leads directly in the app</li>
                                            <li>Download leads via MyShowOnline</li>
                                            <li>Receive a daily CSV file of leads at end of show day</li>
                                        </ul>
                                    </li>
                                </ul>

                                <h3>Need Help?</h3>
                                <p>If you have any questions, please contact:</p>
                                <p>
                                    <strong>Mark Schmidt</strong><br />
                                    <a href="mailto:mschmidt@d2p.com">mschmidt@d2p.com</a>&nbsp;|&nbsp;
                                    <a href="tel:18002254535,112">(800) 225-4535 ext. 112</a>
                                </p>
                            </div>

                            <div className="lead-retrieval-carousel-column">
                                <div>
                                    <div className="phone-carousel-wrap">
                                        <Carousel
                                            autoplay
                                            arrows
                                            dots
                                            infinite
                                            centerMode
                                            centerPadding="80px"
                                            slidesToShow={1}
                                        >
                                            {screens.map((img, i) => (
                                                <div key={i}>
                                                    <div className="phone-slide">
                                                        <img
                                                            src={img}
                                                            alt={`screen-${i + 1}`}
                                                            className="phone-slide-image"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </Carousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="form-group col-12 padding-25-10">
                            <button
                                className="btn btn-danger btn-lg"
                                onClick={() => this.setState({ showLeadRetrievalSendEmailSlider: true })}
                            >
                                Email Instructions
                            </button>
                            <button
                                type="button"
                                onClick={() => this.setState({ showInstructionModal: false })}
                                className="btn btn-primary btn-lg margin-left-15"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </SlidingPane>

                {/*<SlidingPane*/}
                {/*    className='some-custom-class'*/}
                {/*    overlayClassName='showCard'*/}
                {/*    isOpen={this.state.showInstructionModal}*/}
                {/*    title='Electronic Lead Retrieval'*/}
                {/*    onRequestClose={() => this.setState({ showInstructionModal: false })}*/}
                {/*    closeIcon={<i className="fas fa-chevron-right float-left"></i>}*/}
                {/*>*/}
                {/*    <div className="slide-pane-body scrollableDiv">*/}
                {/*        <h1>Electronic Lead Retrieval - {this.state.showInfo.name}</h1>*/}

                {/*        <p>Your company is currently registered to use Electronic Lead Retrieval for the {this.state.showInfo.name} show.</p>*/}
                {/*        <h3>Getting Started</h3>*/}
                {/*        <p>*/}
                {/*            To ensure a smooth experience, please have all booth staff complete the following steps prior to the show:*/}
                {/*        </p>*/}

                {/*        <ol>*/}
                {/*            <li>*/}
                {/*                <b>Download the "D2P Shows" App (available for Apple and Android devices):</b>*/}
                {/*                <ul>*/}
                {/*                    <li>iOS: <a href="https://itunes.apple.com/us/app/d2p-shows/id845230786?mt=8" target="_blank" rel="noopener noreferrer">https://itunes.apple.com/us/app/d2p-shows/id845230786?mt=8</a></li>*/}
                {/*                    <li>Android: <a href="https://play.google.com/store/apps/details?id=com.d2p.d2pshows" target="_blank" rel="noopener noreferrer">https://play.google.com/store/apps/details?id=com.d2p.d2pshows</a></li>*/}
                {/*                </ul>*/}
                {/*            </li>*/}
                {/*            <li><b>Open the app and select the {this.state.showInfo.name} show</b></li>*/}
                {/*            <li>Tap <b>"Lead Retrieval"</b></li>*/}
                {/*            <li>*/}
                {/*                <b>Scan your customized QR code</b>*/}
                {/*                <ul>*/}
                {/*                    <li>This code will be emailed to you approximately one week prior to the show</li>*/}
                {/*                </ul>*/}
                {/*            </li>*/}
                {/*        </ol>*/}

                {/*        <h3>What's Included in Your Package</h3>*/}
                {/*        <ul>*/}
                {/*            <li>Unlimited device access for your full booth staff</li>*/}
                {/*            <li>Built-in badge scanning via the mobile app</li>*/}
                {/*            <li>On-site technical support during the show</li>*/}
                {/*            <li>*/}
                {/*                Lead access and export options, including ability to:*/}
                {/*                <ul>*/}
                {/*                    <li>View and manage leads directly in the app</li>*/}
                {/*                    <li>Download leads via MyShowOnline</li>*/}
                {/*                    <li>Receive a daily CSV file of leads at end of show day</li>*/}
                {/*                </ul>*/}
                {/*            </li>*/}
                {/*        </ul>*/}

                {/*        <h3>Need Help?</h3>*/}
                {/*        <p>If you have any questions, please contact:</p>*/}
                {/*        <p>*/}
                {/*            <strong>Mark Schmidt</strong><br />*/}
                {/*                <a href="mailto:mschmidt@d2p.com">mschmidt@d2p.com</a> |*/}
                {/*                <a href="tel:18002254535,112">(800) 225-4535 ext. 112</a>*/}
                {/*        </p>*/}

                {/*        <div className="phone-carousel-scale">*/}
                {/*            <div className="phone-carousel-wrap">*/}
                {/*                <Carousel*/}
                {/*                    autoplay*/}
                {/*                    arrows*/}
                {/*                    dots*/}
                {/*                    infinite*/}
                {/*                    centerMode*/}
                {/*                    centerPadding="80px"*/}
                {/*                    slidesToShow={1}*/}
                {/*                >*/}
                {/*                    {screens.map((img, i) => (*/}
                {/*                        <div key={i}>*/}
                {/*                            <div className="phone-slide">*/}
                {/*                                <img*/}
                {/*                                    src={img}*/}
                {/*                                    alt={`screen-${i + 1}`}*/}
                {/*                                    className="phone-slide-image"*/}
                {/*                                />*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    ))}*/}
                {/*                </Carousel>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className="modal-footer">*/}
                {/*        <div className="form-group col-12 padding-25-10">*/}
                {/*            <button className="btn btn-danger btn-lg" onClick={() => this.setState({ showLeadRetrievalSendEmailSlider: true })}>Email Instructions</button>*/}
                {/*            <button type="button" onClick={() => this.setState({ showInstructionModal: false })} className="btn btn-primary btn-lg margin-left-15">Close</button>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</SlidingPane>*/}

                <SlidingPane
                    className='some-custom-class'
                    overlayClassName='showCard'
                    isOpen={this.state.showOrderModal}
                    title='Electronic Lead Retrieval Order'
                    onRequestClose={this.hideShowOrderPane}
                    closeIcon={<i className="fas fa-chevron-right float-left"></i>}
                >
                    <div className="slide-pane-body scrollableDiv">
                        <div className="panel-content instruction-modal">
                            <h1>Electronic Lead Retrieval</h1>
                            <div className="sub-header-title"><h2 style={{ textDecoration: 'none' }}>Show Rate: $250 Per Company</h2></div>
                            <div>
                                Enhance your lead acquisition process by capturing leads on your own mobile device. Available for Apple iOS products and Android smartphones/tablets. Requires iOS 11.0 or above, and Android 9.0 or higher.
                            </div>
                            <br />
                            <div className="sub-header-title"><h3>What This Includes:</h3></div>

                            <ul>
                                <li>Unlimited devices - Covers your entire booth staff working the show</li>
                                <li>Access to the show's badge scanner within the app</li>
                                <li>On-site technical assistance during the show</li>
                                <li>Custom online portal to login and view/download your leads live</li>
                            </ul>
                            <br />
                            <div>
                                <img src={multipledevices} className="img-fluid" width="50%" alt="" style={{ border: '0px solid black', maxWidth: 500 }} />
                            </div>
                            <br />

                            <div>To order electronic lead retrieval for your company, please fill out your contact information below.</div>
                            <br />

                            <div className="row">
                                <div className="form-group col-lg-12">
                                    <label className="form-label">Contact</label>
                                    <input type="text" name="contact" value={this.state.formFields.contact || ''} onChange={this.handleInputChange} className="form-control-custom" />
                                </div>

                                <div className="form-group col-lg-6">
                                    <label className="form-label">Phone</label>
                                    <NumberFormat className="form-control-custom" name="telephone" value={this.state.formFields.telephone || ''} onChange={this.handleInputChange} format="###-###-####" mask="" />
                                </div>

                                <div className="form-group col-lg-6">
                                    <label className="form-label">Email</label>
                                    <input type="text" name="email" value={this.state.formFields.email || ''} onChange={this.handleInputChange} className="form-control-custom" />
                                </div>
                            </div>

                            <div>
                                If you have any additional questions, please contact Mark Schmidt at
                                <a href="mailto:mschmidt@d2p.com"> mschmidt@d2p.com</a> or (800)-225-4535, ext. 112
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="form-group col-12 padding-25-10">
                            <button className="btn btn-danger btn-lg" onClick={this.submitLeadRetrievalOrder}> Submit Order</button>
                            <button type="button" onClick={this.hideShowOrderPane} className="btn btn-primary btn-lg margin-left-15">Close</button>
                        </div>
                    </div>
                </SlidingPane>

                <ShowSliders.SponsorshipsSlider showPane={this.state.showSponsorshipsSlider} showInfo={this.props.showInfo} hidePane={() => this.setState({ showSponsorshipsSlider: false })} {...this.props} />
                <ShowSliders.LeadRetrievalSendEmailSlider showPane={this.state.showLeadRetrievalSendEmailSlider} hidePane={() => this.setState({ showLeadRetrievalSendEmailSlider: false })} {...this.props} />
            </Card>
        );
    }
}